import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import * as FilterUtilities from '../../../platform/tsx/filtering/FilterUtilities';

import {
    IQueryFilter,
    IGlobalFilterControl,
    IAttrQueryFilterFieldValue,
    IQueryFilterOptions
} from '../../../../_common/platform/tsx/filtering/Interfaces';

import StringField from '../../../../_common/platform/tsx/StringField';
import DateField from '../../../../_common/platform/tsx/DateField';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import FilterRelationSelect from '../../../../_common/platform/tsx/filtering/FilterRelationSelect';
import EntityValuesSelect from '../../../../_common/platform/tsx/EntityValuesSelect';
import NumberField from '../../../../_common/platform/tsx/NumberField';
import TreeSelect from '../../../../_common/platform/tsx/TreeSelect';
import AttrQueryFilterFieldOptionsSelector from './AttrQueryFilterFieldOptionsSelector';
import AttributeDesigner, { ITreeItem, IToggleStates } from '../../../platform/tsx/attributeDesigner/AttributeDesigner';
import TimePartSelect from '../../../../_common/platform/tsx/filtering/TimePartSelect';
import VariableField from '../../../../_common/platform/tsx/filtering/VariableField';
import ExchangeObjectField from './ExchangeObjectField';

import AttrQueryFilterOptionsDialog, {
    IOptionsDialogProperties
} from '../../../../_common/platform/tsx/filtering/AttrQueryFilterOptionsDialog';

import {
    ATTRIBUTE_TYPES,
    ATTRIBUTE_CONTROL_TYPES,
    ITypeNameElement
} from '../../../platform/ts/ConfigurationConstants';

import { RELATIONS } from '../../../platform/tsx/filtering/Constants';

import { IExpression } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';
import { IDisplayValue } from '../../../platform/ts/Interfaces';

const moment = require('pdc-platform-moment');

export function filterHasControlType(filter: IQueryFilter) {
    if (filter.expression != null) {
        return false;
    }

    const { relation } = filter;

    return (
        relation === RELATIONS.EQUAL ||
        relation === RELATIONS.NOT_EQUAL ||
        relation === RELATIONS.MORE ||
        relation === RELATIONS.LESS ||
        relation === RELATIONS.MORE_OR_EQUAL ||
        relation === RELATIONS.LESS_OR_EQUAL ||
        FilterUtilities.isOneOfRelation(relation) ||
        FilterUtilities.isIsSubnodeOfRelation(relation)
    );
}

export function getValidControlTypes(
    filter: IQueryFilter,
    attributeType: string,
    relation: string,
    dataSourceID: number,
    glob: IGlob
) {
    if (filter.attribute != null && glob.EntityModelsStore.belongsToFunction(filter.attribute, dataSourceID)) {
        if (glob.EntityModelsStore.isFunctionParameter(filter.attribute)) {
            return [
                {
                    type: ATTRIBUTE_CONTROL_TYPES.TEXT,
                    name: 'Input'
                }
            ];
        }
    }

    return FilterUtilities.getValidControlTypes(attributeType, relation, true);
}

function getDefaultType(value: IQueryFilter | string, glob: IGlob, dataSourceID: number): string {
    return glob.EntityModelsStore.getDefaultAttributeType(value, dataSourceID);
}

function getAttributeType(value: IQueryFilter | string, glob: IGlob, dataSourceID: number) {
    return glob.EntityModelsStore.getAttributeType(value, dataSourceID);
}

function getDefaultValue(attributeType: string, relation: string) {
    if (FilterUtilities.isOneOfRelation(relation)) {
        return [];
    }

    switch (attributeType) {
        case ATTRIBUTE_TYPES.STRING:
            return null;

        case ATTRIBUTE_TYPES.INTEGER:
        case ATTRIBUTE_TYPES.BIGINT:
        case ATTRIBUTE_TYPES.REAL:
            return 0;

        case ATTRIBUTE_TYPES.ENUMERATION:
            return [];

        case ATTRIBUTE_TYPES.BOOLEAN:
            return true;

        case ATTRIBUTE_TYPES.DATE: // VR
            return moment().format('YYYY-MM-DD');

        case ATTRIBUTE_TYPES.DATETIME:
            return moment(new Date()).format('YYYY-MM-DDT00:00:00'); //format('yyyy-MM-DDTHH:mm:ss')

        case ATTRIBUTE_TYPES.TIME:
            return '00:00:00';

        default:
            return null;
    }
}

function normalizeRelation(attributeType: string, relation?: string): string {
    // if (oldAttributeType === ATTRIBUTE_TYPES.ENUMERATION) {
    //     return RELATIONS.IS_ONE_OF;
    // }

    if (attributeType === ATTRIBUTE_TYPES.LOGICAL) {
        return undefined;
    }

    const validRelations = FilterUtilities.getValidRelations(attributeType);

    if (validRelations == null) {
        return undefined; //Returns undefined to make null do not appear in configuration.
    }

    if (relation != null && validRelations.indexOf(relation) > -1) {
        return relation;
    } else {
        return validRelations[0];
    }
}

function RemoveButton(props: { onClick(): void }) {
    return (
        <div className="remove-button">
            <span className="glyphicon glyphicon-remove" onClick={props.onClick}></span>
        </div>
    );
}

function IdentationBlock(props: { groupNumber: number; forOR?: boolean; children?: React.ReactNode }) {
    const length = props.groupNumber || 0;

    let placeHolderWidth: number = null;

    if (length > 0) {
        placeHolderWidth = 10 * length;

        if (props.forOR) {
            if (length === 1) {
                placeHolderWidth = null;
            }
        }
    }

    if (placeHolderWidth == null) {
        return props.children;
    }

    return (
        <div className="identation-block">
            <table className="table-borderless w-100">
                <tbody>
                    <tr className="identation-block-row">
                        <td className="place-holder-cell" style={{ width: placeHolderWidth + 'px' }}>
                            <div></div>
                        </td>
                        <td className="component-cell">{props.children}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

// function PlaceHolder(props: { groupNumber: number; forOR?: boolean; }) {
//     let length = props.groupNumber || 0;

//     if (length <= 0) {
//         return null;
//     }

//     let width = 20 * length;

//     if (props.forOR) {
//         if (length === 1) {
//             return null;
//         }
//     } else {
//         width -= 4;
//     }

//     return <div className="place-holder" style={ { width: width + 'px' } }></div>;
// }

function ORRow(props: {
    index: number;
    groupNumber: number;

    onRemove(index: number): void;
}) {
    const handleOnRemove = () => {
        if (typeof props.onRemove === 'function') {
            props.onRemove(props.index);
        }
    };

    return (
        <tr>
            <td className="attribute-column">
                <div className="or-row">
                    <IdentationBlock groupNumber={props.groupNumber} forOR={true}>
                        <div className="container-or">
                            <RemoveButton onClick={handleOnRemove} />
                            <div className="element-or">{'OR'}</div>
                        </div>
                    </IdentationBlock>
                    {/* <PlaceHolder groupNumber={ props.groupNumber } forOR={ true } />
                    <div className="container-or" style={ { display: 'table-cell' } }>
                        <RemoveButton onClick={ handleOnRemove } />
                        <div className="element-or">{ 'OR' }</div>
                    </div> */}
                </div>
            </td>
        </tr>
    );
}

function AttrQueryFilterFieldRow(props: {
    index: number;
    groupNumber: number;
    entitiesTree: ITreeItem[];
    dataSourceID: number;
    entityCollapsedDict: IToggleStates;
    validEntities: string[];
    theme: IValuesCollection;
    tabID: number;
    filter?: IQueryFilter;
    glob: IGlob;

    onEntityCollapsedDictChange(value: IToggleStates): void;

    onAdd?(filter: IQueryFilter): void;
    onChange?(index: number, filter: IQueryFilter): void;
    onRemove?(index: number): void;
    onORClick?(index: number): void;
}) {
    const getFilterCopy = (): IQueryFilter => {
        return $.extend(true, {}, props.filter);
    };

    const normalize = (filter: IQueryFilter) => {
        if (filter.attribute == null && filter.expression == null) {
            delete filter.relation;
            delete filter.value;
            return;
        }

        const { dataSourceID, glob } = props;
        const defaultType = getDefaultType(filter, glob, dataSourceID);

        if (defaultType == null) {
            return;
        }

        if (filter.options != null && cannotHaveOptions(filter)) {
            delete filter.options;
        }

        const relation = filter.relation;
        const attributeType = getAttributeType(filter, glob, dataSourceID);
        const noValue = FilterUtilities.relationDoesNotAllowToHaveValue(relation);

        if (noValue) {
            delete filter.value;
        }

        let valueType = filter.valueType;
        let options = filter.options;

        //EVG: 20.12.2018: It is for migration only. Drop it later.
        if (valueType == null && options != null && options.valueType != null) {
            valueType = options.valueType;
            delete options.valueType;
        }

        const hasControlType = filterHasControlType(filter);

        let validControlTypes: ITypeNameElement[];

        if (hasControlType) {
            validControlTypes = getValidControlTypes(filter, attributeType, relation, dataSourceID, glob);

            if (options == null) {
                filter.options = options = {};
            }
        }

        let controlType: string;

        if (options != null) {
            if (options.controlType != null) {
                let controlTypeIsValid = false;

                if (validControlTypes != null) {
                    if (
                        _.findIndex(validControlTypes, (controlType) => {
                            return controlType.type === options.controlType;
                        }) > -1
                    ) {
                        controlTypeIsValid = true;
                    }
                }

                if (!controlTypeIsValid) {
                    delete options.controlType;
                }

                controlType = options.controlType;
            } else if (validControlTypes != null) {
                controlType = options.controlType = validControlTypes[0].type;
            }
        }

        //Fix Filter's value.
        if (valueType === 'variable' || valueType === 'exchangeObject') {
            //Variable or ExcahgeObject must have a value, which is name of a variable.
            if (noValue || FilterUtilities.filterValueTypeCannotBeChanged(attributeType, relation)) {
                valueType = 'constant';
                delete filter.valueType;
            } else if (typeof filter.value !== 'string') {
                delete filter.value;
            }
        } else if (!noValue) {
            const value = filter.value;

            if (controlType != null && FilterUtilities.isOfValidTimePartControlType(controlType, attributeType)) {
                if (!Array.isArray(value) || value.length === 0) {
                    filter.value = null;
                }
            } else {
                if (value == null || (value === '' && defaultType !== ATTRIBUTE_TYPES.STRING)) {
                    filter.value = getDefaultValue(defaultType, relation);
                } else if (
                    FilterUtilities.isOneOfRelation(relation) ||
                    FilterUtilities.isIsSubnodeOfRelation(relation) ||
                    controlType === ATTRIBUTE_CONTROL_TYPES.DROPDOWN ||
                    controlType === ATTRIBUTE_CONTROL_TYPES.TREE
                ) {
                    if (typeof value === 'string') {
                        if (controlType !== ATTRIBUTE_CONTROL_TYPES.TEXT || value === '') {
                            filter.value = null;
                        }
                    } else if (
                        controlType === ATTRIBUTE_CONTROL_TYPES.DROPDOWN &&
                        !FilterUtilities.isOneOfRelation(relation) &&
                        Array.isArray(value) &&
                        value.length > 1
                    ) {
                        //'=', '>' ect. with Dropdown work in single select mode.
                        //Shifting from Is One Of relations demand conversion from multiply mode to single select one.
                        filter.value = [value[0]]; //Leave the first node.
                    } else if (
                        !Array.isArray(value) ||
                        (controlType === ATTRIBUTE_CONTROL_TYPES.TREE && value.length > 0 && value[0].value == null)
                    ) {
                        //Drop value when shifting to tree, because the formats are incompartiple.
                        filter.value = [];
                    }
                }
            }
        }

        if (_.isEmpty(filter.options)) {
            delete filter.options;
        }
    };

    const handleOnValueChange = (value: string | number | boolean) => {
        const filter = getFilterCopy();

        if (typeof value === 'string') {
            filter.value = value;
        } else {
            filter.value = value != null ? value.toString() : null;
        }

        processValueChange(filter);
    };

    const processValueChange = (filter: IQueryFilter) => {
        normalize(filter);

        if (typeof props.onChange === 'function') {
            props.onChange(props.index, filter);
        }
    };

    const handleOnRelationChange = (value: string) => {
        const filter = getFilterCopy();

        if (FilterUtilities.hasConstantValueType(filter)) {
            if (FilterUtilities.isOneOfRelation(value) && !Array.isArray(filter.value)) {
                filter.value = null;
            } else if (
                FilterUtilities.isIsSubnodeOfRelation(filter.relation) ||
                FilterUtilities.isIsSubnodeOfRelation(value)
            ) {
                filter.value = null;
            }
        }

        filter.relation = value;

        processValueChange(filter);
    };

    const getRelationSelector = (filter: IQueryFilter) => {
        if (filter == null || (filter.attribute == null && filter.expression == null)) {
            return;
        }

        let attributeType: string;

        switch (filter.valueType) {
            case 'variable':
                attributeType = ATTRIBUTE_TYPES.VARIABLE;
                break;

            case 'exchangeObject':
                attributeType = ATTRIBUTE_TYPES.EXCHANGE_OBJECT;
                break;

            default:
                attributeType = getAttributeType(filter, props.glob, props.dataSourceID);
        }

        if (attributeType === ATTRIBUTE_TYPES.LOGICAL) {
            return;
        }

        let defaultType = getDefaultType(filter, props.glob, props.dataSourceID);

        if (filter.attribute != null) {
            const attribute = filter.attribute;

            if (props.glob.EntityModelsStore.belongsToFunction(attribute, props.dataSourceID)) {
                if (props.glob.EntityModelsStore.isFunctionParameter(attribute)) {
                    defaultType = 'functionParameter';
                    attributeType = null;
                }
            }
        }

        return (
            <FilterRelationSelect
                defaultAttributeType={defaultType}
                addSpecialOptions={{ attributeType }}
                value={filter.relation}
                onChange={handleOnRelationChange}
            />
        );
    };

    const getValueLabelChangeHandler = (filter: IQueryFilter) => {
        return (value: string) => {
            if (value != null && value.length > 0) {
                filter.label = value;
            } else {
                delete filter.label;
            }

            processValueChange(filter);
        };
    };

    const handleOnOptionsChange = (value: IQueryFilter) => {
        if (value.valueType !== 'variable' && value.valueType !== 'exchangeObject') {
            const newControlType = value.options.controlType;
            const oldControlType = props.filter.options != null ? props.filter.options.controlType : null;

            if (newControlType !== oldControlType) {
                if (
                    newControlType === ATTRIBUTE_CONTROL_TYPES.TREE ||
                    oldControlType === ATTRIBUTE_CONTROL_TYPES.TREE ||
                    newControlType === ATTRIBUTE_CONTROL_TYPES.DROPDOWN ||
                    oldControlType === ATTRIBUTE_CONTROL_TYPES.DROPDOWN
                ) {
                    delete value.value;
                }
            }
        }

        processValueChange(value);
        //setState(this.state);
    };

    const cannotHaveOptions = (filter: IQueryFilter) => {
        return (
            filter == null ||
            (filter.attribute == null && filter.expression == null) ||
            FilterUtilities.isSpecialRelation(filter.relation)
        );
    };

    const getMoreSelector = (filter: IQueryFilter) => {
        if (cannotHaveOptions(filter)) {
            return;
        }

        return (
            <AttrQueryFilterFieldOptionsSelector
                value={filter}
                dataSourceID={props.dataSourceID}
                theme={props.theme}
                glob={props.glob}
                onChange={handleOnOptionsChange}
            />
        );
    };

    const handleOnTreeValueChange = (value: IDisplayValue[]) => {
        const filter = getFilterCopy();

        filter.value = value;

        processValueChange(filter);
    };

    const handleOnEntitySelectChange = (values: IDisplayValue[]) => {
        const filter = getFilterCopy();

        filter.value = values;

        processValueChange(filter);
    };

    const handleOnVariableOrExchangeObjectChange = (value: string) => {
        const filter = getFilterCopy();

        filter.value = value;

        processValueChange(filter);
    };

    const getGetTreeEntityValuesHandler = (dataSourceID: number, filter: IQueryFilter) => {
        return () => {
            let parentAttribute = filter.options != null ? filter.options.parentAttribute : null;

            if (parentAttribute == null) {
                const entity = props.glob.EntityModelsStore.getReferredEntity(filter.attribute, dataSourceID);

                parentAttribute = props.glob.EntityModelsStore.getEntityDefaultParentAttribute(entity);
            }

            return props.glob.EntityModelsStore.loadTreeEntityValues(
                dataSourceID,
                filter.attribute,
                parentAttribute,
                null,
                props.theme
            );
        };
    };

    const getValueTreeSelect = (values: IDisplayValue[], filter: IQueryFilter, isOneOfRelation: boolean) => {
        const allowMultiselection = isOneOfRelation || FilterUtilities.isIsSubnodeOfRelation(filter.relation);

        return (
            <TreeSelect
                value={values}
                attributeData={{
                    attribute: filter.attribute
                }}
                dataSourceID={props.dataSourceID}
                allowNull={false}
                allowMultiselection={allowMultiselection}
                theme={props.theme}
                getValues={getGetTreeEntityValuesHandler(props.dataSourceID, filter)}
                glob={props.glob}
                onChange={handleOnTreeValueChange}
            />
        );
    };

    const getValueEntitySelect = (attribute: string, values: IDisplayValue[], isOneOfRelation: boolean) => {
        return (
            <EntityValuesSelect
                attributeData={{
                    attribute: attribute,
                    loadKeyAttribute: false
                }}
                value={values}
                dataSourceID={props.dataSourceID}
                selectFirstItemByDefault={false}
                allowNull={true} //Allowing nulls must be allowed here because initial value is unknown.
                selectionType={isOneOfRelation ? 'multiply' : 'single'}
                theme={props.theme}
                glob={props.glob}
                onChange={handleOnEntitySelectChange}
            />
        );
    };

    const getTimePartSelect = (
        values: IDisplayValue[],
        controlType: string,
        allowNull: boolean,
        isOneOfRelation: boolean,
        options: IQueryFilterOptions
    ) => {
        return (
            <TimePartSelect
                value={values}
                type={controlType}
                singleSelectMode={!isOneOfRelation}
                allowNull={allowNull}
                theme={props.theme}
                minYear={options && options.minYear ? options.minYear : null}
                maxYear={options && options.maxYear ? options.maxYear : null}
                timePartControlType={'dropdown'}
                glob={props.glob}
                onChange={handleOnEntitySelectChange}
            />
        );
    };

    const getValueSelector = (filter: IQueryFilter) => {
        if (filter == null || (filter.attribute == null && filter.expression == null)) {
            return;
        }

        const { dataSourceID, glob } = props;
        const defaultType = getDefaultType(filter, glob, dataSourceID);

        if (defaultType == null) {
            return;
        }

        const attributeType = getAttributeType(filter, glob, dataSourceID);

        if (attributeType === ATTRIBUTE_TYPES.LOGICAL) {
            return;
        }

        const { relation } = filter;

        //Attribute with 'Require Value' Relation does not have a value, but the its place is used to enter a Custom Require Value Message.
        if (
            relation !== RELATIONS.REQUIRE_VALUE &&
            (attributeType == null || FilterUtilities.relationDoesNotAllowToHaveValue(relation))
        ) {
            return;
        }

        const options = filter.options;

        let controlType: string;

        if (options != null) {
            controlType = options.controlType;
        }

        if (controlType == null) {
            const validControlTypes = getValidControlTypes(filter, attributeType, relation, dataSourceID, glob);

            //A problem appeared after the decision to make values be selected from Dropdown by default.
            //However, for Expressions it is possible for the ones only that coincide with an Attribute.
            //So default type for Expression should be the next one in the list of valid types.
            if (filter.expression != null && validControlTypes.length > 1) {
                controlType = validControlTypes[1].type;
            } else {
                controlType = validControlTypes[0].type;
            }
        }

        const valueType = FilterUtilities.getValueType(filter);

        if (valueType === 'variable' || attributeType === ATTRIBUTE_TYPES.ANYTYPE) {
            let varibaleName: string;

            if (typeof filter.value === 'string') {
                varibaleName = filter.value;
            } else if (Array.isArray(filter.value) && filter.value.length > 0) {
                varibaleName = filter.value[0].value;
            }

            return <VariableField value={varibaleName} onChange={handleOnVariableOrExchangeObjectChange} />;
        }

        if (valueType === 'exchangeObject' || attributeType === ATTRIBUTE_TYPES.ANYTYPE) {
            let varibaleName: string;

            if (typeof filter.value === 'string') {
                varibaleName = filter.value;
            } else if (Array.isArray(filter.value) && filter.value.length > 0) {
                varibaleName = filter.value[0].value;
            }

            return <ExchangeObjectField value={varibaleName} onChange={handleOnVariableOrExchangeObjectChange} />;
        }

        const keySelect = FilterUtilities.isKeySelect(controlType, filter.options);
        const normalizedValues = FilterUtilities.getNormalizedDisplayValues(filter.value, keySelect);
        const isOneOfRelation = FilterUtilities.isOneOfRelation(relation);

        switch (relation) {
            case RELATIONS.REQUIRE_VALUE:
                return (
                    <StringField
                        value={filter.label} //Custom Require Value Message is stored in the label.
                        onChange={getValueLabelChangeHandler(filter)}
                    />
                );

            case RELATIONS.LIKE:
            case RELATIONS.NOT_LIKE:
                return <StringField value={normalizedValues.firstValue} onChange={handleOnValueChange} />;

            case RELATIONS.IS_SUBNODE_OF:
            case RELATIONS.IS_NOT_SUBNODE_OF:
                return getValueTreeSelect(normalizedValues.values, filter, isOneOfRelation);
        }

        switch (controlType) {
            case ATTRIBUTE_CONTROL_TYPES.TEXT:
                return <StringField value={normalizedValues.firstValue} onChange={handleOnValueChange} />;

            case ATTRIBUTE_CONTROL_TYPES.INTEGER:
            case ATTRIBUTE_CONTROL_TYPES.DECIMAL:
            case ATTRIBUTE_CONTROL_TYPES.NUMBER:
                return (
                    <NumberField
                        value={normalizedValues.firstValue}
                        allowNull={false}
                        integer={defaultType === ATTRIBUTE_TYPES.INTEGER}
                        onChange={handleOnValueChange}
                    />
                );

            case ATTRIBUTE_CONTROL_TYPES.BOOLEAN:
                return <BooleanField value={normalizedValues.firstValue} onChange={handleOnValueChange} />;

            case ATTRIBUTE_CONTROL_TYPES.TREE:
                return getValueTreeSelect(normalizedValues.values, filter, isOneOfRelation);

            case ATTRIBUTE_CONTROL_TYPES.DROPDOWN:
                return getValueEntitySelect(filter.attribute, normalizedValues.values, isOneOfRelation);

            default:
                if (FilterUtilities.isOfValidTimePartControlType(controlType, attributeType)) {
                    return getTimePartSelect(normalizedValues.values, controlType, true, isOneOfRelation, options);
                }

                if (defaultType === ATTRIBUTE_TYPES.ENUMERATION || isOneOfRelation) {
                    return getValueEntitySelect(filter.attribute, normalizedValues.values, isOneOfRelation);
                }

                if (DateTimeFunctions.isTypeOfAnyDate(defaultType)) {
                    return (
                        <DateField
                            value={normalizedValues.firstValue}
                            allowNull={true}
                            type={defaultType}
                            onChange={handleOnValueChange}
                        />
                    );
                }

                break;
        }

        return null;
    };

    const handleORClick = () => {
        if (typeof props.onORClick === 'function') {
            props.onORClick(props.index);
        }
    };

    const handleOnRemove = () => {
        if (typeof props.onRemove === 'function') {
            props.onRemove(props.index);
        }
    };

    const processValueAdd = (filter: IQueryFilter) => {
        if (typeof props.onAdd === 'function') {
            props.onAdd(filter);
        }
    };

    const handleOnAttributeAdd = (value: string[]) => {
        const attribute = value[0];
        const newDefaultType = getDefaultType(attribute, props.glob, props.dataSourceID);

        const filter: IQueryFilter = {
            attribute: attribute,
            relation: normalizeRelation(newDefaultType)
        };

        if (newDefaultType === ATTRIBUTE_TYPES.ENUMERATION) {
            filter.value = getDefaultValue(newDefaultType, filter.relation);
        }

        processValueAdd(filter);
    };

    const handleOnAttributeChange = (values: string[]) => {
        const filter = getFilterCopy();
        const newAttribute = values[0];
        const oldAttributeType = getAttributeType(filter, props.glob, props.dataSourceID);
        const newAttributeType = getAttributeType(newAttribute, props.glob, props.dataSourceID);
        const oldDefaultType = getDefaultType(filter, props.glob, props.dataSourceID);
        const newDefaultType = getDefaultType(newAttribute, props.glob, props.dataSourceID);

        //LL: when 'none' was removed for Relation:
        if (newDefaultType !== oldDefaultType || oldAttributeType !== newAttributeType) {
            filter.relation = normalizeRelation(newDefaultType, filter.relation);
        }

        if (
            filter.valueType !== 'variable' &&
            filter.valueType !== 'exchangeObject' &&
            (newDefaultType !== oldAttributeType || newDefaultType === 'e')
        ) {
            filter.value = getDefaultValue(newDefaultType, filter.relation);
        }

        filter.attribute = newAttribute;
        delete filter.expression;

        processValueChange(filter);
    };

    const handleOnExpressionChange = (value: IExpression) => {
        const filter = getFilterCopy();

        if (
            FilterUtilities.hasConstantValueType(filter) &&
            (filter.expression == null || filter.expression.rettype !== value.rettype)
        ) {
            filter.value = getDefaultValue(value.rettype, filter.relation);
        }

        filter.relation = normalizeRelation(value.rettype, filter.relation);
        filter.expression = value;
        delete filter.attribute;

        if (props.filter == null) {
            processValueAdd(filter);
        } else {
            processValueChange(filter);
        }
    };

    const filter = props.filter;

    let value: string | IExpression;

    if (filter != null) {
        if (filter.attribute != null) {
            value = filter.attribute;
        } else if (filter.expression != null) {
            value = filter.expression;
        }
    }

    const commandButtons = [];

    if (value == null) {
        commandButtons.push({
            title: 'Add Condition - OR',
            onClick: handleORClick
        });
    }

    return (
        <tr className="field-row">
            <td className="attribute-column">
                <IdentationBlock groupNumber={props.groupNumber}>
                    <AttributeDesigner
                        tree={props.entitiesTree}
                        dataSourceID={props.dataSourceID}
                        modes={['attribute', 'expression']}
                        value={value}
                        isForFilter={true}
                        collapsedDict={props.entityCollapsedDict}
                        validEntities={props.validEntities}
                        doNotAddSpecialEntities={true}
                        showRemoveButton={true}
                        commandButtons={commandButtons}
                        minWidth={300}
                        tabID={props.tabID}
                        glob={props.glob}
                        onChange={value == null ? handleOnAttributeAdd : handleOnAttributeChange}
                        onCollapsedDictChange={props.onEntityCollapsedDictChange}
                        onRemove={handleOnRemove}
                        onExpressionChange={handleOnExpressionChange}
                    />
                </IdentationBlock>
                {/* <PlaceHolder groupNumber={ props.groupNumber } />

                <div className="attribute-selector">
                    <AttributeDesigner
                        tree={ props.entitiesTree }
                        dataSourceID={ props.dataSourceID }
                        modes={ ['attribute', 'expression'] }
                        value={ value }
                        isForFilter={ true }
                        collapsedDict={ props.entityCollapsedDict }
                        validEntities={ props.validEntities }
                        doNotAddSpecialEntities={ true }
                        showRemoveButton={ true }
                        commandButtons={ commandButtons }
                        minWidth={ 300 }
                        tabID={ props.tabID }
                        glob={ props.glob }
                        onChange={ value == null ? handleOnAttributeAdd : handleOnAttributeChange }
                        onCollapsedDictChange={ props.onEntityCollapsedDictChange }
                        onRemove={ handleOnRemove }
                        onExpressionChange={ handleOnExpressionChange }
                    />
                </div> */}
            </td>

            <td className="relation-column">{getRelationSelector(filter)}</td>

            <td className="more-column">{getMoreSelector(filter)}</td>

            <td className="value-column">{getValueSelector(filter)}</td>
        </tr>
    );
}

function FilterGroup(props: {
    filters: IQueryFilter[];
    groupNumber: number;
    dataSourceID: number;
    entitiesTree: ITreeItem[];
    theme: IValuesCollection;
    tabID: number;
    validEntities: string[];
    glob: IGlob;

    onChange(filters: IQueryFilter[]): void;
}) {
    const [entityCollapsedDict, setEntityCollapsedDict] = React.useState<IToggleStates>({});

    const getFilters = (): IQueryFilter[] => {
        return props.filters != null ? [...props.filters] : [];
    };

    const handleOnChangeAttributeRow = (index: number, value: IQueryFilter) => {
        const filters = getFilters();

        filters[index] = value;

        props.onChange(filters);
    };

    const handleOnRemoveAttributeRow = (index: number) => {
        const filters = getFilters();

        filters.splice(index, 1);
        props.onChange(filters);
    };

    const handleOnEntityCollapsedDictChange = (value) => {
        setEntityCollapsedDict(value);
    };

    const handleOnAddAttribute = (value: IQueryFilter) => {
        const defaultType = getDefaultType(value, props.glob, props.dataSourceID);

        value.relation = normalizeRelation(defaultType);
        value.value = getDefaultValue(defaultType, value.relation);

        const filters = getFilters();

        filters.push(value);
        props.onChange(filters);
    };

    const handleOnORClick = (index: number) => {
        const filters = getFilters();

        filters.splice(index, 0, {
            left: [],
            right: []
        });

        props.onChange(filters);
    };

    const handleOnRemoveORGroup = (index: number) => {
        const filters = getFilters();

        filters.splice(index, 1);

        props.onChange(filters);
    };

    const getLeftFilterChangeHandler = (index: number) => {
        return (value: IQueryFilter[]) => {
            const filters = getFilters();

            filters[index].left = value;
            props.onChange(filters);
        };
    };

    const getRightFilterChangeHandler = (index: number) => {
        return (value: IQueryFilter[]) => {
            const filters = getFilters();

            filters[index].right = value;
            props.onChange(filters);
        };
    };

    const getORFilterGroup = (filter: IQueryFilter, index: number, groupNumber: number) => {
        return [
            <FilterGroup
                key={'left-filter-group-' + groupNumber}
                filters={filter.left}
                groupNumber={groupNumber}
                dataSourceID={props.dataSourceID}
                entitiesTree={props.entitiesTree}
                theme={props.theme}
                tabID={props.tabID}
                validEntities={props.validEntities}
                glob={props.glob}
                onChange={getLeftFilterChangeHandler(index)}
            />,
            <ORRow
                key={'or-element-' + groupNumber}
                index={index}
                groupNumber={groupNumber}
                onRemove={handleOnRemoveORGroup}
            />,
            <FilterGroup
                key={'right-filter-group-' + groupNumber}
                filters={filter.right}
                groupNumber={groupNumber}
                dataSourceID={props.dataSourceID}
                entitiesTree={props.entitiesTree}
                theme={props.theme}
                tabID={props.tabID}
                validEntities={props.validEntities}
                glob={props.glob}
                onChange={getRightFilterChangeHandler(index)}
            />
        ];
    };

    const rows = [];
    const filters = props.filters;

    let index = 0;

    while (index < filters.length) {
        const filter = filters[index];

        if (filter.attribute != null || filter.expression != null) {
            rows.push(
                <AttrQueryFilterFieldRow
                    key={'attribute-' + filter.attribute + '-' + index + '-' + props.groupNumber}
                    index={index}
                    groupNumber={props.groupNumber}
                    filter={filter}
                    dataSourceID={props.dataSourceID}
                    theme={props.theme}
                    entitiesTree={props.entitiesTree}
                    entityCollapsedDict={entityCollapsedDict}
                    validEntities={props.validEntities}
                    tabID={props.tabID}
                    glob={props.glob}
                    onChange={handleOnChangeAttributeRow}
                    onRemove={handleOnRemoveAttributeRow}
                    onEntityCollapsedDictChange={handleOnEntityCollapsedDictChange}
                />
            );
        } else {
            rows.push(getORFilterGroup(filter, index, props.groupNumber + 1));
        }

        index++;
    }

    rows.push(
        <AttrQueryFilterFieldRow
            key={'bottom-selector-' + props.groupNumber}
            index={index}
            groupNumber={props.groupNumber}
            dataSourceID={props.dataSourceID}
            entitiesTree={props.entitiesTree}
            entityCollapsedDict={entityCollapsedDict}
            validEntities={props.validEntities}
            theme={props.theme}
            tabID={props.tabID}
            glob={props.glob}
            onAdd={handleOnAddAttribute}
            onORClick={handleOnORClick}
            onEntityCollapsedDictChange={handleOnEntityCollapsedDictChange}
        />
    );

    return <React.Fragment>{rows}</React.Fragment>;
}

export interface IAttrQueryFilterFieldOptions extends IParameterFieldBaseOptions {
    dataSourceID?: number;
    disableGlobalFilterControl?: boolean;
}

export interface IAttrQueryFilterFieldProperties {
    value?: IAttrQueryFilterFieldValue;
    dataSourceID: number;
    theme: IValuesCollection;
    tabID: number;
    validEntities?: string[]; // Entities that are shown when Allow Multiple Root Entities is unchecked.
    disableGlobalFilterControl?: boolean;
    glob: IGlob;
    options?: IAttrQueryFilterFieldOptions;

    onChange?(value: IAttrQueryFilterFieldValue): void;
}

function getPropValue(value: IAttrQueryFilterFieldValue): IAttrQueryFilterFieldValue {
    if (value != null) {
        if (Array.isArray(value)) {
            //Obsolete format.
            return {
                filters: [...value],
                globalFilterControl: {}
            };
        } else if (Array.isArray(value.filters)) {
            return $.extend(true, {}, value);
        } else if (value.globalFilterControl != null) {
            return {
                filters: [],
                globalFilterControl: $.extend(true, {}, value.globalFilterControl)
            };
        }
    }

    return {
        filters: [],
        globalFilterControl: {}
    };
}

export default function AttrQueryFilterField(props: IAttrQueryFilterFieldProperties) {
    const dataSourceID = props.dataSourceID || props.options?.dataSourceID;

    props.glob.EntityModelsStore.useLoadModelsHook(dataSourceID != null ? [dataSourceID] : null);

    const [value, setValue] = React.useState<IAttrQueryFilterFieldValue>(getPropValue(props.value));

    React.useEffect(() => {
        setValue(getPropValue(props.value));
    }, [JSON.stringify(props.value)]);

    const processOnChange = (value: IAttrQueryFilterFieldValue) => {
        setValue(value);

        if (typeof props.onChange === 'function') {
            const result = $.extend(true, {}, value);

            if (_.isEmpty(result.globalFilterControl)) {
                delete result.globalFilterControl;
            }

            props.onChange(result);
        }
    };

    const getValueCopy = () => {
        return $.extend(true, {}, value);
    };

    const handleFilterGroupChange = (filters: IQueryFilter[]) => {
        const valueCopy = getValueCopy();

        valueCopy.filters = [...filters];
        processOnChange(valueCopy);
    };

    const handleGlobalFilterControlChange = (value: IGlobalFilterControl) => {
        const valueCopy = getValueCopy();

        valueCopy.globalFilterControl = $.extend(true, {}, value);
        processOnChange(valueCopy);
    };

    const handleShowOptionsDialog = () => {
        props.glob.DialogActions.createDialogCustom<IOptionsDialogProperties, any, any>(
            'Global Filter Control',
            handleGlobalFilterControlChange,
            () => {},
            () => {},
            {
                deny: false,
                confirmTitle: 'OK',
                componentOptions: {
                    value: value.globalFilterControl,
                    dataSourceID: props.dataSourceID
                },
                Component: AttrQueryFilterOptionsDialog
            }
        );
    };

    const entitiesTree = props.glob.EntityModelsStore.getEntitiesTreeByDS(dataSourceID);
    const { options } = props;

    let dataChangedMark: React.JSX.Element;
    let disableGlobalFilterControl = props.disableGlobalFilterControl;
    let tabID = props.tabID;
    let theme = props.theme;

    if (options != null) {
        if (disableGlobalFilterControl == null) {
            disableGlobalFilterControl = options.disableGlobalFilterControl;
        }

        if (tabID == null) {
            tabID = options.tabID;
        }

        if (theme == null) {
            theme = options.theme;
        }
    }

    let globalFilterControlElement: React.JSX.Element;

    if (disableGlobalFilterControl !== true) {
        globalFilterControlElement = (
            <span
                className="glyphicon glyphicon-cog"
                title={'Global Filter Control'}
                onClick={handleShowOptionsDialog}
            ></span>
        );

        if (!_.isEmpty(value.globalFilterControl)) {
            dataChangedMark = <span className="glyphicon glyphicon-equalizer" onClick={handleShowOptionsDialog}></span>;
        }
    }

    return (
        <div className="attrquery-filter-field">
            <div className="caption">
                {globalFilterControlElement}

                {dataChangedMark}

                <label>{'Filter'}</label>
            </div>

            <table className="field-row-table">
                <thead className="field-row-header">
                    <tr>
                        <th className="attribute-column">
                            <div className="attribute-header">{'Attribute'}</div>
                        </th>

                        <th className="relation-column">
                            <div className="relation-header">{'Relation'}</div>
                        </th>

                        <th className="more-column">
                            <div className="more-header">{'More...'}</div>
                        </th>

                        <th className="value-column">
                            <div className="value-header">{'Value'}</div>
                        </th>

                        <th className="empty-column"></th>
                    </tr>
                </thead>
                <tbody>
                    <FilterGroup
                        key="root-filter-group"
                        filters={value.filters}
                        groupNumber={0}
                        dataSourceID={dataSourceID}
                        entitiesTree={entitiesTree}
                        theme={theme}
                        tabID={tabID}
                        validEntities={props.validEntities}
                        glob={props.glob}
                        onChange={handleFilterGroupChange}
                    />
                </tbody>
            </table>
        </div>
    );
}
